import classnames from "classnames";

const Flex = ({
    justify = "start",
    align = "start",
    inline = false,
    column = false,
    wrap = false,
    className = "",
    tag: TAG = "div",
    children,
    gap = 1,
    ...rest
}) => {
    return (
        <TAG
            className={classnames(
                {
                    "d-flex"                      : !inline,
                    "d-inline-flex"               : inline,
                    [`justify-content-${justify}`]: justify,
                    [`align-items-${align}`]      : align,
                    "flex-column"                 : column,
                    "flex-wrap"                   : wrap,
                    [`column-gap-${gap}`]         : gap
                },
                className
            )}
            {...rest}>
            {children}
        </TAG>
    );
};

export default Flex;
